import { Flex } from '@chakra-ui/react';
import { motion } from "framer-motion";
import React, { useEffect, useState } from 'react';
import { ChatIcon } from '@chakra-ui/icons';
import { Message, MessageOption, MessageOptionsProps, MessageSelectorProps, ProximityChatMessage } from './types';
import useCoveyAppState from '../../../hooks/useCoveyAppState';

/** A single message option, displayed to the user */
function MessageDisplay(props: MessageOption): JSX.Element {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const { type, textOpacity } = props;
    const { socket, myPlayerID, userName, currentTownID } = useCoveyAppState();

    return <motion.div 
    initial={{
        opacity: 0,
    }}
    animate={{
        opacity: textOpacity,
    }}
    transition={{
        type: "tween",
        ease: "easeInOut",
        duration: 1,
    }}>
        <Flex 
            onMouseEnter={() => setIsMouseOver(true)} 
            onMouseLeave={() => setIsMouseOver(false)}
            onClick={() => {
                const msg: ProximityChatMessage = {
                    body: type,
                    author: myPlayerID,
                    userName,
                    townID: currentTownID,
                    dateSent: new Date(),
                };
                socket?.emit('proximityChatMessage', msg);
            }}
            opacity={isMouseOver ? 0.5 : 1}
            cursor='pointer'>
                {type}
        </Flex>
    </motion.div>
 }

/** Displays a row of message options that the user can select from. */
function MessageOptions(props: MessageOptionsProps): JSX.Element {
    const {isMouseOver} = props;
    const [textOpacity, setTextOpacity] = useState<number>(0);

    useEffect(() => isMouseOver ? setTextOpacity(1) : setTextOpacity(0), [isMouseOver]);

    return <Flex direction='row' justifyContent='space-around' alignItems='center' width='90%'>
        <MessageDisplay type={Message.hello} textOpacity={textOpacity}/>
        <MessageDisplay type={Message.ily} textOpacity={textOpacity}/>
        <MessageDisplay type={Message.letsChat} textOpacity={textOpacity}/>
        <MessageDisplay type={Message.lonely} textOpacity={textOpacity}/>
        <MessageDisplay type={Message.thanks} textOpacity={textOpacity}/>
    </Flex>
 }

/** The initial width of the entire message selection component. */
const INITIAL_WIDTH = 300;

/**
 * A message-select menu for the WorldMap screen.
 */
export default function MessageSelector(props: MessageSelectorProps): JSX.Element {
    const { top, left } = props;
    const [isMouseOver, setIsMouseOver] = useState<boolean>(false);
    const [tileWidth, setTileWidth] = useState<number>(INITIAL_WIDTH);

    useEffect(() => isMouseOver ? setTileWidth(INITIAL_WIDTH+200) : setTileWidth(INITIAL_WIDTH)
    , [isMouseOver]);

    return  <Flex 
        borderRadius={10} 
        shadow="lg" 
        onMouseEnter={() => setIsMouseOver(true)} 
        onMouseLeave={() => setIsMouseOver(false)}
        alignItems="center"
        justifyContent="center">
     <motion.div
        style={{position: 'absolute', top, left, height: 57, width: 500, backgroundColor: 'white', borderRadius: 10}} 
        initial={{
            width: INITIAL_WIDTH,
        }}
        animate={{
            width: tileWidth
        }}
        transition={{
            type: "tween",
            ease: "easeInOut",
        duration: 0.3,
        }}
        drag
        dragMomentum={false}
    >
        <Flex 
            justifyContent='space-around' 
            alignItems='center'
            height="100%"
            width="100%">
        {isMouseOver ? <></> : 
            <Flex justifyContent='space-around' alignItems='center' width="70%">
                <ChatIcon/>
                <Flex direction="column" alignItems="flex-start" justifyContent="center">
                    <div style={{fontSize: 14}}>Send a message!</div>
                    <div style={{fontSize: 14}}>Click and hold to drag.</div>
                </Flex>
            </Flex>}
        {isMouseOver ? <MessageOptions isMouseOver={isMouseOver}/> : <></>}
        </Flex>
    </motion.div>
    </Flex>;
 }